'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var baseColors = exports.baseColors = {
	black: /* istanbul ignore next */function black() {
		var percentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		return 'rgba(0, 0, 0, ' + percentage + ')';
	},
	darkGrey: '#4a5254',
	charcoalGrey: '#646b6f',
	grey: '#8d9092',
	lightGrey: '#cecece',
	offWhite: '#f1f1f1',
	white: '#ffffff',
	lightBlue: '#53b3f3',
	blue: '#1890e0',
	green: '#5eb65f',
	lightGreen: '#5bc75d',
	orange: '#f7961d',
	red: '#fb0000',
	purple: '#bd10e0',
	darkBlue: '#1d6f99'
};

exports.default = {
	baseColors: baseColors
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/styles/colors.styles.js